import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import "../../css/inventory-style.css"
import '../../css/reports-v2.css'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import { DeleteCharactersNotAccepted, ItemDesc, MonthInLetters, NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { getIndexElement } from '../../functions/searchInObject'
import { pricesFormat } from '../../functions/pricesFormat';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from '../../components/LoadingWindow';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet, getDataSetSales3, getDataSetSales4 } from '../../functions/generateDataSetExcel';
import ModalOrders from '../../components/ModalComponent';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLines } from '../../functions/dateFormat';
import { confirmCloseAlert } from '../../functions/alerts';
import { Menu } from '../../components/Menu/Menu';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

const spoilageMonthlyChartOptions = {
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) => ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        y: {
            ticks: { callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }) },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        x: { grid: { display: false } },
    },
};

const spoilageTopChartOptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) => ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        x: {
            ticks: { callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }) },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        y: { grid: { display: false } },
    },
};

export default class SpoilageReport extends Component {
    constructor(props) {
        super(props)
        this.BarGraph1 = React.createRef()
        this.ModalLoading = React.createRef();

    }

    state = {
        HeaderTable: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        HeaderTable2: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        BodyCustomer: [],
        BodyFilterCustomer: [],
        Body: [],
        BodyFilter: [],
        AllInformation: [],
        Totals: [],
        showModal1: false,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        currentCustomer: {
            CustomerNo: '',
            CustomerName: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        AllNoProccessInformation: [],
        ShortDetail: [],
        CustomerDetail: [],
        ShortDetailWithTotal: [],
        flag: true,
        Mode: 1

    }


    TableHeader(splitStartDate, splitEndDate) {
        let years = [{ year: '', span: 3 }]
        let years2 = [{ year: '', span: 3 }]
        let months = []
        let General = [{ year: '', month: '', title: ['   Key   ', 'Item Code', 'Description'] }]
        let General2 = [{ year: '', month: '', title: ['   Key   ', 'Customer No', 'Customer Name'] }]

        for (let a = Number(splitStartDate[0]); a <= Number(splitEndDate[0]); a++) {
            if (a === Number(splitStartDate[0]) && a === Number(splitEndDate[0])) {
                var cont1 = 0
                for (let b = Number(splitStartDate[1]); b <= Number(splitEndDate[1]); b++) {
                    cont1++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['', 'Spoilage ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['', 'Spoilage ($)'] }])

                }
                const temp = {
                    year: String(a),
                    span: cont1 * 2
                }
                years.push(temp)
                years2.push(temp)
                break
            } else if (a === Number(splitStartDate[0])) {
                var cont2 = 0
                for (let b = Number(splitStartDate[1]); b <= 12; b++) {
                    cont2++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['', 'Spoilage ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['', 'Spoilage ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: cont2 * 2
                }
                years.push(temp)
                years2.push(temp)

            } else if (a === Number(splitEndDate[0])) {
                var cont3 = 0
                for (let b = 1; b <= Number(splitEndDate[1]); b++) {
                    cont3++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: [ '', 'Spoilage ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: [ '', 'Spoilage ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: cont3 * 2
                }
                years.push(temp)
                years2.push(temp)

            } else {

                for (let b = 1; b <= 12; b++) {

                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: [ '', 'Spoilage ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: [ '', 'Spoilage ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: 12 * 2
                }
                years.push(temp)
                years2.push(temp)
            }

        }

        this.setState({
            HeaderTable: {
                Row1: years,
                Row2: months,
                Row3: General
            },
            HeaderTable2: {
                Row1: years2,
                Row2: months,
                Row3: General2
            }
        })

        return
    }
    clearAll() {
        this.setState({
            HeaderTable: {
                Row1: [],
                Row2: [],
                Row3: []
            },
            Body: [],
            BodyFilter: [],
            AllInformation: [],
            Totals: [],
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: ''
            },
            AllNoProccessInformation: [],
            ShortDetail: [],
        })
    }

    getTransactionTypeLabel(row) {
        const safeRow = row || {}
        const invoiceType = String(safeRow.InvoiceType || '').toUpperCase()
        const itemCode = String(safeRow.ItemCode || '').toUpperCase()
        const itemDesc = String(safeRow.ItemCodeDesc || '').toUpperCase()

        const looksLikeDiscount =
            invoiceType.includes('DISCOUNT') ||
            invoiceType === 'D' ||
            invoiceType === 'SD' ||
            itemCode.includes('DISCOUNT') ||
            itemDesc.includes('DISCOUNT')

        return looksLikeDiscount ? '/SALES DISCOUNT' : '/SPOILAGE'
    }

    async getShorts() {
        this.ModalLoading.current.showState(true);
        this.clearAll()
        var date1 = document.getElementById('startSpoilageFilterDate').value
        var date2 = document.getElementById('endSpoilageFilterDate').value
        const splitStartDate = date1.split('-')
        const splitEndDate = date2.split('-')
        if (splitStartDate.length === 3 && splitEndDate.length === 3) {
            this.TableHeader(splitStartDate, splitEndDate)
            const data = {
                Start: date1,
                End: date2,
                idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId'))
            }
            const result = await getInformationWithData('/reports/spoilage', data)
            console.log(result)
            let temporal = []
            let customer = []
            if (result.status.code === 1) {
                result.data = result.data.map((row) => ({
                    ...row,
                    TransactionType: this.getTransactionTypeLabel(row),
                }))

                this.setState({ AllInformation: result.data })
                for (const item of result.data) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    const index2 = getIndexElement(customer, 'CustomerNo', item.CustomerNo)
                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []
                    if (index === -1 && splitDate.length === 3) {

                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS 
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }

                    }

                    if (index2 === -1 && splitDate.length === 3) {

                        const json = {
                            CustomerNo: item.CustomerNo,
                            CustomerName: item.BillToName,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        customer.push(json)
                    } else if (splitDate.length === 3) {
                        const element = customer[index2]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                customer[index2] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS 
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            }
                        }

                    }
                }

                for (const month of this.state.HeaderTable.Row2) {
                    for (const item of temporal) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal.Months.push(add2)
                                item.Detail[indexyear] = temporal
                            }
                        }
                    }

                    for (const item of customer) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal.Months.push(add2)
                                item.Detail[indexyear] = temporal
                            }
                        }
                    }

                }





                temporal = this.Order(temporal, 'ItemCode', true)
                customer = this.Order(customer, 'CustomerNo', true)

                temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')
                for (const item of temporal) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                for (const item of customer) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }


                await this.setState({ BodyCustomer: customer, BodyFilterCustomer: customer, Body: temporal, BodyFilter: temporal, Totals: this.getTotals(temporal), AllNoProccessInformation: result.data })
            }
        } else {
            confirmCloseAlert('incorrect', 'Both dates must be established\n to make the report!')
        }
        this.ModalLoading.current.showState(false);
    }

    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

    searchShorts = e => {

        let search = e.target.value;

        let orders = this.state.Body.filter((item) => {
            if (((
                this.contains(item.ItemCode, search) ||
                this.contains(item.ProductLine, search) ||
                this.contains(item.ItemCodeDesc, search)

            ))
            ) {
                return item
            } else {
                return null
            }
        });
        this.setState({ BodyFilter: orders, Totals: this.getTotals(orders) });

    }
    searchShorts2 = e => {

        let search = e.target.value;

        let orders = this.state.BodyCustomer.filter((item) => {
            if (((
                this.contains(item.CustomerNo, search) ||
                this.contains(item.CustomerName, search)

            ))
            ) {
                return item
            } else {
                return null
            }
        });
        this.setState({ BodyFilterCustomer: orders, Totals: this.getTotals(orders) });

    }

    getTotals(temporal) {
        let totals = []
        let flag = true
        let count = 0
        for (const item of temporal) {
            for (const detail of item.Detail) {
                for (let a = 0; a < detail.Months.length; a++) {
                    if (flag) {

                        totals.push('$')
                        totals.push(detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts))
                    } else {
                        count += 1
                        totals[count] += detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts)
                        count += 1
                    }

                }
            }
            flag = false
            count = 0
        }
        for (let num = 0; num < totals.length; num++) {
            if (totals[num] !== '$') {
                totals[num] = NumberFormat(pricesFormat(totals[num]))
            }
        }

        return totals
    }

    Order(arreglo, llave, bandera) {

        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }

    handleModalOpen = (modal) => {
        var temporal = this.state[modal]
        temporal = true
        this.setState({ [modal]: temporal })
    }

    handleModalClose = (modal) => {
        var temporal = this.state[modal]
        temporal = false
        this.setState({ [modal]: temporal })
    }
    clearOnlyShortDetail() {
        this.setState({
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: '',
                totalShorts: 0,
                totalQuantityShipped: 0,
                totalQuantityOrdered: 0,
                totalShort: 0
            },
            ShortDetail: [],
            currentCustomer: {
                CustomerNo: '',
                CustomerName: '',
                totalShorts: 0,
                totalQuantityShipped: 0,
                totalQuantityOrdered: 0,
                totalShort: 0
            },
            CustomerDetail: [],
        })
    }

    async DetailofShort(itemCode) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentItem
        temporal.ItemCode = itemCode.ItemCode
        temporal.ItemCodeDesc = itemCode.ItemCodeDesc
        temporal.ProductLine = itemCode.ProductLine

        let SpecificDetail = []
        var total = 0
        var totalShipped = 0
        var totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.ItemCode === itemCode.ItemCode) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }

        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()

        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            ItemCode: itemCode.ItemCode
        }
        const resultImg = await getInformationWithData('/Items/get/Img', data)

        if (resultImg.status.code === 1) {
            if (resultImg.data.itemURLImage !== undefined) {
                if (resultImg.data.itemURLImage !== '') {
                    const date = new Date().getTime()
                    temporal.itemURL = `${resultImg.data.itemURLImage}?${date}`
                } else {
                    temporal.itemURL = ''
                }
            } else {
                temporal.itemURL = ''
            }
        }

        await this.setState({ ShortDetail: SpecificDetail, currentItem: temporal })
        var totalRow = {
            InvoiceDate: 'TOTAL',
            QuantityShipped: totalShipped,
            QuantityOrdered: totalOrdered,
            TotalShortD: '$' + pricesFormat(total)
        }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }
    async DetailbyCustomer(info) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentCustomer
        temporal.CustomerNo = info.CustomerNo
        temporal.CustomerName = info.CustomerName

        let SpecificDetail = []
        var total = 0
        var totalShipped = 0
        var totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.CustomerNo === info.CustomerNo) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }

        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()

        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')



        await this.setState({ CustomerDetail: SpecificDetail, currentCustomer: temporal })
        var totalRow = {
            InvoiceDate: 'TOTAL',
            QuantityShipped: totalShipped,
            QuantityOrdered: totalOrdered,
            TotalShortD: '$' + pricesFormat(total)
        }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async OrderPriceMargins(option, pos) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "Item Code":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Product Line":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilter: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilter: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }
    async OrderPriceMargins2(option, pos) {
        var temporal = this.state.BodyFilterCustomer
        switch (option) {
            case "Customer No":
                temporal = OrderArray(temporal, "CustomerNo", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Customer Name":
                temporal = OrderArray(temporal, "CustomerName", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilterCustomer: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilterCustomer: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async orderShorts(array, conditions, key) {

        const l = array.length

        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {

                const pos1 = await getIndexElement(array[j].Detail, 'year', conditions.year)
                const pos2 = await getIndexElement(array[j].Detail[pos1].Months, 'month', conditions.month)
                const pos3 = await getIndexElement(array[j + 1].Detail, 'year', conditions.year)
                const pos4 = await getIndexElement(array[j + 1].Detail[pos3].Months, 'month', conditions.month)
                const m = array[j].Detail[pos1].Months[pos2][key] === '-' ? 0 : Number(array[j].Detail[pos1].Months[pos2][key])
                const n = array[j + 1].Detail[pos3].Months[pos4][key] === '-' ? 0 : Number(array[j + 1].Detail[pos3].Months[pos4][key])
                if (this.state.flag) {
                    if (m > n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                } else {
                    if (m < n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                }

            }
        }


        return array
    }

    valueRadioButton = async e => {
        let stat = Number(e.target.value)
        this.setState({ Mode: stat })
        if (stat === 1) {

            this.setState({ Totals: this.getTotals(this.state.BodyFilter) })
        } else {

            this.setState({ Totals: this.getTotals(this.state.BodyFilterCustomer) })
        }
    }

    getSpoilageKPIs() {
        const rows = this.state.AllNoProccessInformation
        if (!rows.length) return null

        const totalSpoilage = rows.reduce((sum, row) => sum + Number(row.shorts || 0), 0)
        const totalUnitsShipped = rows.reduce((sum, row) => sum + Number(row.QuantityShipped || 0), 0)
        const uniqueItems = new Set(rows.map((row) => row.ItemCode).filter(Boolean)).size
        const uniqueCustomers = new Set(rows.map((row) => row.CustomerNo).filter(Boolean)).size

        return {
            totalSpoilage,
            totalUnitsShipped,
            uniqueItems,
            uniqueCustomers,
        }
    }

    getMonthlySpoilageChartData() {
        const rows = this.state.AllNoProccessInformation
        const byMonth = {}

        for (const row of rows) {
            if (!row.InvoiceDate) continue
            const dateParts = row.InvoiceDate.split('-')
            if (dateParts.length < 2) continue
            const key = `${dateParts[0]}-${dateParts[1]}`
            byMonth[key] = (byMonth[key] || 0) + Number(row.shorts || 0)
        }

        const keys = Object.keys(byMonth).sort()
        return {
            labels: keys.map((k) => {
                const [year, month] = k.split('-')
                return `${MonthInLetters(Number(month))} ${year}`
            }),
            datasets: [
                {
                    label: 'Spoilage ($)',
                    data: keys.map((k) => byMonth[k]),
                    borderColor: 'rgba(239, 68, 68, 0.95)',
                    backgroundColor: 'rgba(239, 68, 68, 0.20)',
                    pointBackgroundColor: 'rgba(239, 68, 68, 1)',
                    pointRadius: 3,
                    tension: 0.3,
                    fill: true,
                },
            ],
        }
    }

    getTopItemsSpoilageChartData() {
        const rows = this.state.AllNoProccessInformation
        const byItem = {}
        for (const row of rows) {
            if (!row.ItemCode) continue
            const itemLabel = row.ItemCodeDesc ? `${row.ItemCode} - ${row.ItemCodeDesc}` : row.ItemCode
            if (!byItem[itemLabel]) byItem[itemLabel] = 0
            byItem[itemLabel] += Number(row.shorts || 0)
        }

        const sorted = Object.entries(byItem)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 8)

        return {
            labels: sorted.map((entry) => entry[0]),
            datasets: [
                {
                    label: 'Spoilage ($)',
                    data: sorted.map((entry) => entry[1]),
                    backgroundColor: 'rgba(245, 158, 11, 0.82)',
                    borderRadius: 4,
                },
            ],
        }
    }

    getTopCustomersSpoilageChartData() {
        const rows = this.state.AllNoProccessInformation
        const byCustomer = {}
        for (const row of rows) {
            const customerNo = row.CustomerNo || 'N/A'
            const customerName = row.BillToName || ''
            const customerLabel = customerName ? `${customerNo} - ${customerName}` : customerNo
            if (!byCustomer[customerLabel]) byCustomer[customerLabel] = 0
            byCustomer[customerLabel] += Number(row.shorts || 0)
        }

        const sorted = Object.entries(byCustomer)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 8)

        return {
            labels: sorted.map((entry) => entry[0]),
            datasets: [
                {
                    label: 'Spoilage ($)',
                    data: sorted.map((entry) => entry[1]),
                    backgroundColor: 'rgba(37, 99, 235, 0.82)',
                    borderRadius: 4,
                },
            ],
        }
    }

    render() {
        const hasData = this.state.Body.length > 0
        const kpis = hasData ? this.getSpoilageKPIs() : null
        return (
            <div className="rpt-page">
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                <div className="rpt-page-header">
                    <h1 className="rpt-page-title">Spoilage Report</h1>
                    <p className="rpt-page-subtitle">Analyze spoilage totals by item or customer across any date range.</p>
                </div>

                <div className="rpt-card rpt-controls">
                    <div className="row g-3 align-items-end">
                        <div className="col-sm-12 col-md-4">
                            <label className="rpt-label" htmlFor="startSpoilageFilterDate">Start Date</label>
                            <input className="rpt-input" id='startSpoilageFilterDate' type="date" />
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <label className="rpt-label" htmlFor="endSpoilageFilterDate">End Date</label>
                            <input className="rpt-input" id='endSpoilageFilterDate' type="date" />
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <button onClick={() => this.getShorts()} type="button" className="rpt-btn-primary w-100">
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                        {hasData && (
                            <div className="col-12 d-flex justify-content-between align-items-center flex-wrap gap-3">
                                <div className="rpt-tabs">
                                    <input className="d-none form-check-input textRadioButtonSize" value={1} onChange={this.valueRadioButton} checked={this.state.Mode === 1} type="radio" id='typeItemSpoilageReport' name="typeSpoilageReport" />
                                    <label className={`rpt-tab mb-0 ${this.state.Mode === 1 ? 'active' : ''}`} htmlFor='typeItemSpoilageReport' style={{ cursor: 'pointer' }}>
                                        Item List
                                    </label>
                                    <input className="d-none form-check-input textRadioButtonSize" value={2} onChange={this.valueRadioButton} checked={this.state.Mode === 2} type="radio" id='typeCustomerSpoilageReport' name="typeSpoilageReport" />
                                    <label className={`rpt-tab mb-0 ${this.state.Mode === 2 ? 'active' : ''}`} htmlFor='typeCustomerSpoilageReport' style={{ cursor: 'pointer' }}>
                                        Customer List
                                    </label>
                                </div>
                                <div>
                                    {this.state.Mode === 1 ?
                                        <ExcelDocument
                                            hidden={this.state.Body.length === 0}
                                            archname={'Spoilage ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                            sheetname2={['Spoilage Detail ' + getValueCookie('Company')]}
                                            sheetname={'Spoilage ' + getValueCookie('Company')}
                                            data={getDataSetSales4(this.state.HeaderTable.Row1, this.state.HeaderTable.Row2, this.state.HeaderTable.Row3, this.state.Body, this.state.Totals)}
                                            data2={[getDataSet(this.state.AllInformation, ['Transaction Type', 'Item Code', 'Product Line', 'Description', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Price ($)', 'Total Sales ($)'], ['TransactionType', 'ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPrice', 'shorts'])]}
                                        />
                                        :
                                        <ExcelDocument
                                            hidden={this.state.Body.length === 0}
                                            archname={'Spoilages ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                            sheetname2={['Spoilages Detail ' + getValueCookie('Company')]}
                                            sheetname={'Spoilages ' + getValueCookie('Company')}
                                            data={getDataSetSales3(this.state.HeaderTable2.Row1, this.state.HeaderTable2.Row2, this.state.HeaderTable2.Row3, this.state.BodyCustomer, this.state.Totals)}
                                            data2={[getDataSet(this.state.AllInformation, ['Transaction Type', 'Type', 'Description', 'Invoice No', 'Customer No', 'Customer Name', 'Sales Person', 'Date', 'Total Spoilage ($)'], ['TransactionType', 'ItemCode', 'ItemCodeDesc', 'InvoiceNo', 'CustomerNo', 'BillToName', 'SalespersonNo', 'InvoiceDate', 'shorts'])]}
                                        />
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {hasData && kpis && (
                    <div className="rpt-kpi-row">
                        <div className="row g-3">
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-red">
                                    <div className="rpt-kpi-label">Total Spoilage / Discounts</div>
                                    <div className="rpt-kpi-value">${NumberFormat(pricesFormat(kpis.totalSpoilage))}</div>
                                    <div className="rpt-kpi-sub">Amount in selected period</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-amber">
                                    <div className="rpt-kpi-label">Units Impacted</div>
                                    <div className="rpt-kpi-value">{Math.round(kpis.totalUnitsShipped).toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">From spoilage transactions</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-blue">
                                    <div className="rpt-kpi-label">Items With Spoilage</div>
                                    <div className="rpt-kpi-value">{kpis.uniqueItems.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">Unique item codes</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-purple">
                                    <div className="rpt-kpi-label">Clients Impacted</div>
                                    <div className="rpt-kpi-value">{kpis.uniqueCustomers.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">Unique customers</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {hasData && (
                    <div className="rpt-charts-row">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <div className="rpt-chart-card">
                                    <div className="rpt-card-title">Spoilage / Discount Trend by Month</div>
                                    <Line data={this.getMonthlySpoilageChartData()} options={spoilageMonthlyChartOptions} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rpt-chart-card">
                                    <div className="rpt-card-title">Top Items by Spoilage (Code - Name)</div>
                                    <Bar data={this.getTopItemsSpoilageChartData()} options={spoilageTopChartOptions} />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="rpt-chart-card">
                                    <div className="rpt-card-title">Top Clients by Spoilage / Discount</div>
                                    <Bar data={this.getTopCustomersSpoilageChartData()} options={spoilageTopChartOptions} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {hasData && (
                    <div className="rpt-card">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                            <div className="rpt-card-title mb-0">{this.state.Mode === 1 ? 'Item Spoilage' : 'Customer Spoilage'}</div>
                            <div className="rpt-search-wrap" style={{ maxWidth: 360, flex: 1 }}>
                                <AiOutlineSearch />
                                {this.state.Mode === 1 ? (
                                    <input type="text" autoComplete='off' className="rpt-search" id='searchSpoilageItem' placeholder='Search by Item Code or Description...' onChange={this.searchShorts} />
                                ) : (
                                    <input type="text" autoComplete='off' className="rpt-search" id='searchSalesItem' placeholder='Search by Customer No or Customer Name...' onChange={this.searchShorts2} />
                                )}
                            </div>
                        </div>

                        {this.state.Mode === 1 ?
                            <div className="rpt-table-wrapper">
                                <table className="rpt-table">
                                    <thead>
                                        <tr className='table-blue-header'>
                                            {this.state.HeaderTable.Row1.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-blue-header' : 'tableAquaeHeader')} key={i} scope="col" colSpan={col.span}>{col.year}</th>
                                            ))}
                                        </tr>
                                        <tr className='table-blue-header'>
                                            <th className='text-center table-blue-header' colSpan={3}></th>
                                            {this.state.HeaderTable.Row2.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={i} colSpan={2}>{col.month}</th>
                                            ))}
                                        </tr>
                                        <tr className='table-blue-header'>
                                            {this.state.HeaderTable.Row3.map((col, c) => (
                                                col.title.map((tit, t) => (
                                                    <th onClick={() => this.OrderPriceMargins(tit, col)} className={'text-center ' + (col.month === '' ? 'table-blue-header' : Number(c) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={t}>
                                                        {tit}
                                                        {tit !== '' && <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>}
                                                    </th>
                                                ))
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((element, e) => (
                                            <tr onClick={() => this.DetailofShort(element)} key={uuidv4()}>
                                                <td className='text-center'>{e + 1}</td>
                                                <td className='text-start'>{element.ItemCode}</td>
                                                <td className='text-start'>{element.ItemCodeDesc}</td>
                                                {element.Detail.map((year) => (
                                                    year.Months.map((month) => (
                                                        month.shorts === '-' ?
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className='text-center'></td>
                                                                <td className='text-center'>-</td>
                                                            </React.Fragment>
                                                            :
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className='text-end'>{month.dolar}</td>
                                                                <td className='text-end'>{NumberFormat(pricesFormat(month.shorts))}</td>
                                                            </React.Fragment>
                                                    ))
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td>TOTALS</td>
                                            <td></td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className='text-end' key={t}>{total}</td>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            :
                            <div className="rpt-table-wrapper">
                                <table className="rpt-table">
                                    <thead>
                                        <tr className='table-blue-header'>
                                            {this.state.HeaderTable2.Row1.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-blue-header' : 'tableAquaeHeader')} key={i} scope="col" colSpan={col.span}>{col.year}</th>
                                            ))}
                                        </tr>
                                        <tr className='table-blue-header'>
                                            <th className='text-center table-blue-header' colSpan={3}></th>
                                            {this.state.HeaderTable2.Row2.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={i} colSpan={2}>{col.month}</th>
                                            ))}
                                        </tr>
                                        <tr className='table-blue-header'>
                                            {this.state.HeaderTable2.Row3.map((col, c) => (
                                                col.title.map((tit, t) => (
                                                    <th onClick={() => this.OrderPriceMargins2(tit, col)} className={'text-center ' + (col.month === '' ? 'table-blue-header' : Number(c) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={t}>
                                                        {tit}
                                                        {tit !== '' && <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>}
                                                    </th>
                                                ))
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilterCustomer.map((element, e) => (
                                            <tr onClick={() => this.DetailbyCustomer(element)} key={uuidv4()}>
                                                <td className='text-center'>{e + 1}</td>
                                                <td className='text-center'>{element.CustomerNo}</td>
                                                <td className='text-start'>{element.CustomerName}</td>
                                                {element.Detail.map((year) => (
                                                    year.Months.map((month) => (
                                                        month.shorts === '-' ?
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className='text-center'></td>
                                                                <td className='text-center'>-</td>
                                                            </React.Fragment>
                                                            :
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className='text-end'>{month.dolar}</td>
                                                                <td className='text-end'>{NumberFormat(pricesFormat(month.shorts))}</td>
                                                            </React.Fragment>
                                                    ))
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>TOTALS</td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className='text-end' key={t}>{total}</td>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        }
                    </div>
                )}

                {!hasData && (
                    <div className="rpt-empty">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
                        </svg>
                        <p>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                    </div>
                )}
                <ModalOrders title={this.state.Mode === 1 ? 'Type: ' + this.state.currentItem.ItemCode : 'Customer Spoilages: ' + this.state.currentCustomer.CustomerName} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    {this.state.Mode === 1 ?
                        <div>
                            <div className='row d-flex justify-content-center'>
                                <div className='col-12 my-3'>
                                    <div className='row'>
                                        <div className='col-6 titleTotal text-end'>
                                            <p>Type:</p>
                                        </div>
                                        <div className='col-6 TitleText'>
                                            <p>{this.state.currentItem.ItemCode}</p>
                                        </div>
                                        <div className='col-6 titleTotal text-end'>
                                            <p>Description: </p>
                                        </div>
                                        <div className='col-6 TitleText'>
                                            <p>{this.state.currentItem.ItemCodeDesc}</p>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4 py-4">
                                    <ExcelDocument archname={'Spoilage ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} sheetname={'Spoilage ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} data={getDataSet(this.state.ShortDetailWithTotal, ['Invoice No', 'Transaction Type', 'Customer No', 'Customer Name', 'Sales Person', 'Date', 'Total Spoilage($)'], ['InvoiceNo', 'TransactionType', 'CustomerNo', 'BillToName', 'SalespersonNo', 'InvoiceDate', 'TotalShortD'])} />
                                </div>
                            </div>
                            <div className='row pt-2'>
                                <div className='col-12 tableFixHead table-hover'>
                                    <table className='table table-hover'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th>Invoice No</th>
                                                <th>Transaction Type</th>
                                                <th>Customer No</th>
                                                <th>Customer Name</th>
                                                <th>Sales Person</th>
                                                <th>Date</th>
                                                <th></th>
                                                <th>Total Spoilage($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.ShortDetail.map((item, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{item.InvoiceNo}</td>
                                                        <td className='text-center'>{item.TransactionType}</td>
                                                        <td className='text-center'>{item.CustomerNo}</td>
                                                        <td className='text-start'>{item.BillToName}</td>
                                                        <td className='text-center'>{item.SalespersonNo}</td>
                                                        <td className='text-center'>{DateFormatMAS90(item.InvoiceDate)}</td>
                                                        <td className='text-end'>{'$'}</td>
                                                        <td className='text-end'>{NumberFormat(pricesFormat(item.shorts))}</td>
                                                    </tr>
                                                ))
                                            }


                                        </tbody>
                                        <tfoot className='tfoot'>
                                            <tr className='bg-secondary text-light'>
                                                <td className='text-start'></td>
                                                <td className='text-center'></td>
                                                <td className='text-center'></td>
                                                <td className='text-start'></td>
                                                <td className='text-start'></td>
                                                <td className='text-center'>{'TOTAL'}</td>
                                                <td className='text-end'>{'$'}</td>
                                                <td className='text-end'>{NumberFormat(pricesFormat(this.state.currentItem.totalShorts))}</td>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row d-flex justify-content-center'>
                                <div className='col-12 my-3'>
                                    <div className='row'>
                                        <div className='col-6 titleTotal text-end'>
                                            <p>Customer No:</p>
                                        </div>
                                        <div className='col-6 TitleText'>
                                            <p>{this.state.currentCustomer.CustomerNo}</p>
                                        </div>
                                        <div className='col-6 titleTotal text-end'>
                                            <p>Customer Name: </p>
                                        </div>
                                        <div className='col-6 TitleText'>
                                            <p>{this.state.currentCustomer.CustomerName}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4 py-4">
                                    <ExcelDocument archname={'Spoilage Customer ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} sheetname={'Spoilage ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName)} data={getDataSet(this.state.ShortDetailWithTotal, ['Invoice No', 'Transaction Type', 'Type', 'Description', 'Sales Person', 'Date', 'Total Spoilage($)'], ['InvoiceNo', 'TransactionType', 'ItemCode', 'ItemCodeDesc', 'SalespersonNo', 'InvoiceDate', 'TotalShortD'])} />
                                </div>
                                <div className='col-3'></div>
                            </div>
                            <div className='row pt-2'>
                                <div className='col-12 tableFixHead'>
                                    <table className='table table-hover'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th>Invoice No</th>
                                                <th>Transaction Type</th>
                                                <th>Type</th>
                                                <th>Description</th>
                                                <th>Sales Person</th>
                                                <th>Date</th>
                                                <th></th>
                                                <th>Total Spoilage($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.CustomerDetail.map((item, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{item.InvoiceNo}</td>
                                                        <td className='text-center'>{item.TransactionType}</td>
                                                        <td className='text-center'>{item.ItemCode}</td>
                                                        <td className='text-start'>{item.ItemCodeDesc}</td>
                                                        <td className='text-center'>{item.SalespersonNo}</td>
                                                        <td className='text-center'>{DateFormatMAS90(item.InvoiceDate)}</td>
                                                        <td className='text-end'>{'$'}</td>
                                                        <td className='text-end'>{NumberFormat(pricesFormat(item.shorts))}</td>
                                                    </tr>
                                                ))
                                            }


                                        </tbody>
                                        <tfoot className='tfoot'>
                                            <tr className='bg-secondary text-light'>
                                                <td className='text-center'></td>
                                                <td className='text-center'></td>
                                                <td className='text-center'></td>
                                                <td className='text-start'></td>
                                                <td className='text-center'>{'TOTAL'}</td>
                                                <td className='text-end'></td>
                                                <td className='text-end'>{'$'}</td>
                                                <td className='text-end'>{NumberFormat(pricesFormat(this.state.currentCustomer.totalShorts))}</td>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                            </div>
                        </div>
                    }

                </ModalOrders>


            </div>
        )
    }

}